// extracted by mini-css-extract-plugin
export var drawerContent = "_3f-0";
export var valueBlock = "_3f-1";
export var valueBlockFrom = "_3f-2 _3f-1";
export var valueBlockTo = "_3f-3 _3f-1";